"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var VSteps_1 = require("../../VSteps");
var SRow = (0, styled_components_1.default)('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  margin: 10px 0;\n"], ["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  margin: 10px 0;\n"])));
var SLine = (0, styled_components_1.default)('hr')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: block;\n  height: 1px;\n  border: 0;\n  border-top: 1px solid\n    ", ";\n  margin: 1em 0;\n  padding: 0;\n  width: 100%;\n  margin: 10px;\n"], ["\n  display: block;\n  height: 1px;\n  border: 0;\n  border-top: 1px solid\n    ", ";\n  margin: 1em 0;\n  padding: 0;\n  width: 100%;\n  margin: 10px;\n"])), function (props) {
    var _a, _b;
    return props.isDone
        ? (_a = props.mainColor) !== null && _a !== void 0 ? _a : '#137cbd'
        : (_b = props.secondaryColor) !== null && _b !== void 0 ? _b : '#c7cbd3';
});
var StepsUpperBar = function (props) {
    var mainCtx = (0, react_1.useContext)(VSteps_1.MainStepsContext);
    var count = react_1.default.Children.count(props.children);
    var children = [];
    react_1.default.Children.forEach(props.children, function (child, index) {
        children.push(child);
        if (index < count - 1) {
            children.push(react_1.default.createElement(SLine, { key: "StepBarLine".concat(index), isDone: child.props.currentStep > index, mainColor: mainCtx.mainColor, secondaryColor: mainCtx.secondaryColor }));
        }
    });
    return react_1.default.createElement(SRow, null, children);
};
exports.default = StepsUpperBar;
var templateObject_1, templateObject_2;
